<script setup lang="ts">
import type { Partner } from '@/types/types'
const { t } = useI18n()

defineProps<{
  partner: Partner
  accounts?: any[]
}>()

const emit = defineEmits<{
  (e: 'onStatusUpdate', account: any): void
  (e: 'onSelectedAccountDetails', account: any): void
  (e: 'onSelectedAccountConfiguration', account: any): void
}>()

const updateAccountStatus = (account) => {
  account.isActive = !account.isActive
  emit('onStatusUpdate', account)
}

const selectAccountDetails = (account) => {
  emit('onSelectedAccountDetails', account)
}

const selectAccountConfiguration = (account) => {
  emit('onSelectedAccountConfiguration', account)
}
</script>

<template>
  <ul role="list" class="flex flex-col gap-y-4 overflow-y-auto">
    <li
      v-for="account in accounts"
      :key="account.id"
      class="flex items-center justify-between gap-x-6 rounded-md border bg-muted py-5 pl-2 pr-5"
    >
      <div class="flex flex-col items-center justify-center gap-x-4 md:flex-row">
        <BaseSwitch
          v-if="!partner.isUsingOpenApi"
          :id="`is${account.name}Active`"
          v-model="account.isActive"
          @click="() => updateAccountStatus(account)"
        />
        <div class="flex flex-col items-center justify-center md:items-start">
          <p class="mb-1 text-sm font-semibold text-foreground">
            {{ t('pages.marketplace.marketplacePage.account') }} {{ account.publicId }}
          </p>
          <div v-if="!partner.isUsingOpenApi" class="flex items-center">
            <p class="text-xs text-muted-foreground">
              {{
                account.isActive
                  ? t('pages.marketplace.marketplacePage.active')
                  : t('pages.marketplace.marketplacePage.inactive')
              }}
            </p>
          </div>
        </div>
      </div>
      <div class="flex flex-col items-center gap-x-2 md:flex-row">
        <Button variant="outline" @click="() => selectAccountDetails(account)">
          {{ t('pages.marketplace.marketplacePage.accountDetailsBtn') }}
        </Button>
        <Button
          v-if="!partner.isUsingOpenApi"
          variant="default-primary"
          @click="() => selectAccountConfiguration(account)"
        >
          {{ t('pages.marketplace.marketplacePage.associate') }}
        </Button>
      </div>
    </li>
  </ul>
</template>
